module.exports = __webpack_public_path__ + "static/media/about_1_2.14748496.png";